export default __webpack_public_path__ + "static/media/buy_now_2.d3d4badf.jpg";